import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { GetFittingModelList_pdp_base_info_fitting_model_list_item_list as Model } from '../../../../../model-size/graphql/fitting-model-list_types.2';
import { ModelItem } from './ModelItem';

interface ModelListProps {
  modelList: Model[];
  displayCount: number | null;
}

export const ModelList: React.FC<React.PropsWithChildren<ModelListProps>> = ({ modelList, displayCount }) => {
  return (
    <List>
      {modelList.slice(0, displayCount ?? modelList.length).map((model, index) => (
        <ModelItem key={`${model.name}-${index}`} model={model} />
      ))}
    </List>
  );
};

const List = styled.div`
  padding: 4px 16px 0;

  > div:nth-of-type(n + 2) {
    border-top: 1px solid ${vars.v3Color.gray100};
  }
`;
